import { Component } from 'react';
import BootstrapDropdown from 'react-bootstrap/Dropdown'
import BootstrapDropdownButton from 'react-bootstrap/DropdownButton'

export default class Dropdown extends Component {

    setValue(value) {
        this.props.setValue(value);
    }
    render() {
        return (
            <BootstrapDropdownButton onSelect={(value) => this.setValue(value)} title={this.props.value}>
                {this.props.values.map(value => <BootstrapDropdown.Item key={value} eventKey={value} as='button'>{value}</BootstrapDropdown.Item>)}
            </BootstrapDropdownButton>
        );
    }
}